const {
    REACT_APP_GRUAS_ENV = 'prod',
    REACT_APP_API_ROOT
} = process.env

export {
    REACT_APP_GRUAS_ENV,
    REACT_APP_API_ROOT
}